import React from 'react';

/** The fields Recharts passes to a custom tooltip that this component reads. */
interface ChartTooltipProps {
  active?: boolean;
  payload?: ReadonlyArray<{ payload?: { label?: string; valueLabel?: string; tooltip?: string } }>;
}

/** Exact values on hover: the full label and its count or percentage. */
export const ChartTooltip: React.FC<ChartTooltipProps> = ({ active, payload }) => {
  const datum = payload?.[0]?.payload;
  if (!active || !datum) return null;
  return (
    <div className="rounded-lg border border-border bg-surface-raised px-3 py-2 text-xs">
      <p className="font-medium text-foreground">{datum.label}</p>
      <p className="mt-0.5 tabular-nums text-muted-foreground">{datum.tooltip ?? datum.valueLabel}</p>
    </div>
  );
};
